import React from "react";
import I18n from "../../../../commons/I18n/I18n";
import BlacklistRule from "../../../../commons/model/BlacklistRule";
import { generateRoute } from "../../../../commons/utils/Router";
import Th from "../../../../components/table/Th";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_BLACK_LIST_RULE_DETAIL } from "../../../../routing/Routes";
import { goToRoute } from "../../../../utils/Router";
import { OnSortHandler, SortState } from "../../../../utils/Sort";

interface BlackListRuleListTableProps {
    data: BlacklistRule[];
    error: string;
    onSort: OnSortHandler;
    sort: SortState;
    renderSelectTd?: (itemId: string)=> React.ReactNode;
}

const goToItemDetail = (itemId: string): void => {
  goToRoute(generateRoute(ROUTE_COMPANY_USER_BLACK_LIST_RULE_DETAIL, {
    id: itemId,
  } ));
};

export default class BlackListRuleListTable extends React.Component<BlackListRuleListTableProps> {
  public render(): React.ReactNode {
    const {data, renderSelectTd} = this.props;

    return (
      <table className="table table-hover">
        <thead>{this.renderTH()}</thead>
        <tfoot>{this.renderTH()}</tfoot>
        <tbody>
          {data && data.map((blackListRule: BlacklistRule) => (
            <tr key={blackListRule.id}
              onClick={() => goToItemDetail(blackListRule.id)}
              className={"tr-cursor"}
            >
              {renderSelectTd ? renderSelectTd(blackListRule.id) : null}
              <td>
                {blackListRule.id}
              </td>
              <td>
                {blackListRule.reports}
              </td>
              <td>
                {blackListRule.days}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  private renderTH(): React.ReactNode {
    const {sort, children, onSort} = this.props;
    const commonProps = {
      sort,
      onSort,
    };

    return (
      <tr>
        {children}
        <Th text={I18n.tr(I18nKeys.IDENTIFICADOR)}
          columnName={"id"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.MULTAS_ACUMULADAS)}
          columnName={"reports"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.DIAS)}
          columnName={"days"}
          {...commonProps}
        />
      </tr>
    );
  }
}
